/**
 * FIELD-001C Section C · Operations project-summary card.
 *
 * Extracted from `OperationsProjectDetail.jsx` so the truthful
 * stage / next-milestone / completion-date rendering is directly
 * testable in isolation (see
 * `web/src/__tests__/OperationsProjectSummaryCard.field001c.test.jsx`)
 * while the real Ops detail page keeps mounting the same
 * component.
 *
 * This card is presentation-only — it never fetches, mutates or
 * routes. Every visible caption is derived from the shared
 * `projectPresentation` helper so every surface tells the same
 * lifecycle-aware story for the same project.
 */
import React from "react";
import {
    projectCompletionField,
    projectNextMilestone,
    projectStageLabel,
} from "@/lib/projectPresentation";

export default function ProjectSummaryCard({ project }) {
    const completion = projectCompletionField(project);
    return (
        <section className="rounded-xl border border-[#E5E7EB] bg-white p-5" data-testid="opd-summary-card">
            <div className="text-[10px] tracking-[0.14em] uppercase text-[#4B5565] font-medium">Current phase</div>
            <div className="mt-1 text-base font-medium text-[#131B2F]" data-testid="opd-current-phase">
                {projectStageLabel(project)}
            </div>
            <div className="mt-3 flex items-center gap-3">
                <div className="flex-1 h-1.5 rounded-full bg-[#F0F1F5] overflow-hidden">
                    <div className="h-full bg-[#3E9E2E]" style={{ width: `${project?.progress || 0}%` }} />
                </div>
                <span className="text-xs text-[#131B2F] font-medium tabular-nums">{project?.progress || 0}%</span>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
                <div>
                    <div className="text-[#4B5565]">Next milestone</div>
                    <div className="mt-0.5 text-[#131B2F] font-medium" data-testid="opd-next-milestone">
                        {projectNextMilestone(project)}
                    </div>
                </div>
                <div>
                    <div className="text-[#4B5565]" data-testid="opd-completion-label">{completion.label}</div>
                    <div
                        className="mt-0.5 text-[#131B2F] font-medium"
                        data-testid="opd-completion-value"
                        data-tone={completion.tone}
                    >
                        {completion.value}
                    </div>
                </div>
            </div>
        </section>
    );
}
